import React, { useEffect, useMemo, useState } from 'react';
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import { useHistory } from "react-router";

const calculateTimeLeft = (startDate) => {
    const difference = startDate - (new Date()).getTime();

    let timeLeft = {};

    if (difference > 0) {
        timeLeft = {
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60),
        };
    }

    return timeLeft;
};

function CountdownTimer({ startDate }) {
    const history = useHistory();
    
    const initialTimeLeft = useMemo(() => calculateTimeLeft(startDate), [startDate]);

    const [timeLeft, setTimeLeft] = useState(initialTimeLeft);

    useEffect(() => {
        const redirect = () => {
            setTimeout(() => {
            history.push("/result");
            }, 3000);
        };
        const interval = setInterval(() => {
            const currentTimeLeft = calculateTimeLeft(startDate);

            if (!Object.keys(currentTimeLeft).length) {
                clearInterval(interval);
                redirect();
            }
            setTimeLeft(currentTimeLeft);
        }, 1000);

        return () => {
            clearInterval(interval)
        }
    }, [startDate, history]);


    const timerComponents = Object.keys(timeLeft).map((interval) => {
        return (
            <span key={interval}>
                {timeLeft[interval]} {interval}{" "}
            </span>
        );
    });
    return (
        <div>
            {timerComponents.length ? timerComponents : <ErrorMessage><span>Time's up!</span></ErrorMessage>}
        </div>
    );
}

export default CountdownTimer;